import { api } from "../../shared/timeclock/services";
import { apiAuthenticationRequest, dismissMessage, setApiError, Dispatch } from "../../shared/timeclock/actions/index";
import * as enrollment from "../../shared/timeclock/actions/enrollment";
import { SignatureRegistry } from "../reducers";
import { DeviceResult, DeviceType } from "../../shared/timeclock/models";

export const DEVICE_CAPTURE = "DEVICE_CAPTURE";
export const DEVICE_STATUS = "DEVICE_STATUS";
export const DEVICE_AUTH_SUCCESS = "DEVICE_AUTH_SUCCESS";
export const DEVICE_AUTH_FAIL = "DEVICE_AUTH_FAIL";

let deviceHub = null;

export function deviceUploadSignatures() {
    return async (dispatch: Dispatch, getState: () => {signatures: SignatureRegistry}): Promise<void> => {
        if (deviceHub) {
            const supportedDevices = await deviceHub.server.registerSignatures(getState().signatures.items);

            dispatch({ type: DEVICE_STATUS, supportedDevices });
        }
    };
}

export function deviceConnect() {
    return (dispatch: Dispatch): unknown => {
        const w: any = window;

        if (deviceHub || !w.jQuery) {
            return;
        }

        return w.jQuery
            .getScript("http://localhost:8080/signalr/hubs", () => {
                const connection = w.jQuery.connection;
                connection.hub.url = "http://localhost:8080/signalr";
                deviceHub = connection.deviceHub;

                deviceHub.client.onDeviceCapture = (deviceId: string, readerId: string, result: unknown) => {
                    console.log("onDeviceCapture()");
                    dispatch(deviceCapture(deviceId, readerId, result));
                };

                connection.hub.start().done(() => {
                    dispatch(deviceUploadSignatures());
                });

                connection.hub.disconnected(function () {
                    dispatch({ type: DEVICE_STATUS, supportedDevices: null });
                    setTimeout(function() {
                        connection.hub.start();
                    }, 5000); // restart connection after 5 seconds.
                });
            })
            .fail(() => {
                console.log("Failed to load device hub");
                dispatch({ type: DEVICE_STATUS, supportedDevices: null });
            });
    };
}

export function deviceCapture(deviceId: string, readerId: string, data: unknown): {type: string, result: DeviceResult} {
    return {
        type: DEVICE_CAPTURE,
        result: { deviceId, readerId, data }
    };
}

export function deviceRequestIdentification(readerId: string, captureResult: unknown) {
    return (dispatch: Dispatch): void => {
        deviceHub.server
            .tryAuthenticate(readerId, captureResult)
            .done((authResponse: { personRef: number; data: string; device: DeviceType; meta: string; }) => {
                console.log("Invocation of tryAuthenticate succeeded, personref: " + authResponse.personRef);
                dispatch({ type: DEVICE_AUTH_SUCCESS, personRef: authResponse.personRef });
                dispatch(
                    apiAuthenticationRequest({
                        signature: authResponse.data,
                        device: authResponse.device,
                        personRef: authResponse.personRef
                    })
                );
            })
            .fail((error: {message: string}) => {
                console.log("Invocation of tryAuthenticate failed. Error: " + error);
                dispatch({ type: DEVICE_AUTH_FAIL, error });
                setTimeout(() => {
                    dispatch(dismissMessage());
                }, 2000);
            });
    };
}

export function deviceCreateEnrollmentFile(device: string, readerId: string, personRef: number, meta: string, results: unknown[]) {
    return (dispatch: Dispatch): void => {
        deviceHub.server
            .createEnrollmentFile(readerId, personRef, meta, results)
            .done(async (data: string) => {
                console.log("Invocation of createEnrollmentFile succeeded");

                const enrollmentRequest = { device, meta, personRef, data };

                try {
                    await api.enroll(enrollmentRequest);
                    await dispatch(enrollment.complete());
                } catch (error) {
                    await dispatch(setApiError("EnrollmentErrors", error));
                    await dispatch(enrollment.reset());
                }
            })
            .fail(function(error: unknown) {
                console.log("Invocation of createEnrollmentFile failed. Error: " + error);
                dispatch(enrollment.deviceServerError());
            });
    };
}
